import styled from 'styled-components';
import { EmptyButton, getTheme } from 'mol-ui';

export const Container = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    font-size: 14px;
    margin-bottom: 15px;
    position: relative;
`;

export const IconContainer = styled(EmptyButton)`
    margin-left: 10px;
`;

export const Title = styled.span`
    margin-left: 5px;
`;

export const TreeDrawing = styled.div`
    border-bottom: 1px solid ${ getTheme('textColor') };
    border-left: 1px solid ${ getTheme('textColor') };
    height: 10px;
    left: -10px;
    opacity: 0.5;
    position: absolute;
    top: 1px;
    width: 10px;
`;
